module.exports = __webpack_public_path__ + "img/eq.d194abd4.jpg";